import {
  biaInterfaceTypeOptions,
  biaIpTypeOptions,
  diaAccessTechOptions,
} from "@/common/const";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const diaSubFormStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "text",
    label: "Bandwidth (in Mbps)",
    name: "bandWidth",
    required: true,
    patternMessage: "Value not satisfied range from 0.128 to 10,000",
    pattern:
      /^(?:0\.(?:12[89]|1[3-9]\d|[2-9]\d{1,2})|[1-9]\d{0,3}(?:\.\d{1,3})?|10000(?:\.0{1,3})?)$/,
  },
  {
    inputType: "select",
    label: "Access Technology",
    name: "AccessTechnology",
    required: true,
    defaultValue: diaAccessTechOptions[0].value,
    options: diaAccessTechOptions,
  },
  {
    inputType: "select",
    label: "IP",
    name: "IP",
    required: true,
    defaultValue: biaIpTypeOptions[0].value,
    options: biaIpTypeOptions,
  },
  {
    inputType: "select",
    label: "Interface",
    name: "interface",
    required: true,
    defaultValue: biaInterfaceTypeOptions[0].value,
    options: biaInterfaceTypeOptions,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: true,
    defaultValue: "1",
    options: [...contractTermsOptions],
  },
];
export default diaSubFormStrategy;
